export default __webpack_public_path__ + "static/2-e3fcf7a5aeb8b22b44379d39c369f3c2.jpeg";